import { Box, styled } from '@mui/material';

/** The panel's body: the two fields one under the other, and the draft's chips below them. */
export const FilterFieldsStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  minWidth: 0
}));
